import { createContext, use } from 'react'

interface StepData {
  stepId: string
  analyticsPageName: string | null
}

export const StepContext = createContext({} as StepData)

export const useStepContext = () => {
  return use(StepContext)
}
